export * from './icons.module';
export * from './info-icon/info-icon.component';
export * from './questionmark-circel-icon/questionmark-circel-icon.component';
export * from './check-circle-fill/check-circle-fill.component';
export * from './gender-female/gender-female.component';
export * from './gender-male/gender-male.component';
